<template>
    <div class="MyQuestionBank">
        <el-menu 
            :default-active="activeIndex" 
            class="el-menu-demo" 
            mode="horizontal" 
            text-color="#828181"
            @select="handleSelect"
            active-text-color="#0080ff"
        >
            <el-menu-item index="1">自建题库</el-menu-item>
            <el-menu-item index="2">我的收藏</el-menu-item>
        </el-menu>
        <div class="body">
            <div v-if="activeIndex == '1'"> 
                <div class="title-box">
                    <span class="title">题库列表</span>
                    <span class="num">共 {{myTotal}} 条记录</span>
                    <span title="刷新" @click="myRefresh" class="el-icon-refresh-right"></span>
                </div>
                <div class="operation">
                    <el-form :inline="true" :model="myFormItem" class="demo-form-inline">
                        <el-form-item>
                            <el-input size="small" v-model="myFormItem.name" placeholder="请输入要搜索的题库名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input size="small" v-model="myFormItem.type" placeholder="请输入要搜索的题库类别"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onMySerach">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-button size="small" @click="setNewQuestionBank" type="primary">新建题库</el-button>
                        <!-- <el-button size="small" type="primary">导入题库</el-button> -->
                        
                        <el-popconfirm
                                class="popconfirm"
                                title="确定删除已选中的题库吗？"
                                @confirm="onDelMyLists"
                            >
                            <el-button slot="reference" size="small" type="danger">删除</el-button>
                        </el-popconfirm>
                    </div>
                </div>
                <el-table
                    v-loading="myTableLoading"
                    ref="multipleTable"
                    :data="myTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="myHandleSelectionChange"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="题库编号"
                        width="120"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.quesNo ? scope.row.quesNo : '暂无'}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        prop="name"
                        label="题库名称"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="type"
                        label="题库类别"
                    ></el-table-column>
                    
                    <el-table-column
                        align="center"
                        prop="createName"
                        label="创建人"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="num"
                        label="试题数"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="备注信息"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.remark ? scope.row.remark : '暂无'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        width="300"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.num == 0" type="primary" :underline="false" @click="myCreated(scope.row)" >创建试题</el-link>
                            <el-link v-else type="primary" :underline="false" @click="myEditQues(scope.row)" >编辑试题</el-link>
                            <el-link  type="primary" :underline="false" @click="myEditBank(scope.row)" >编辑题库</el-link>
                            
                            <el-link  type="primary" :underline="false" @click="toPreview(scope.row)" >预览</el-link>
                            <el-popconfirm
                                :append-to-body="false"
                                placement="left"
                                style="margin-left: 10px;"
                                class="popconfirm"
                                title="确定删除该题库吗？"
                                @confirm="myDelete(scope.row)"
                            >
                                <el-link slot="reference" type="primary" :underline="false" >删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-box">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="myPageSize"
                        @current-change="myCurrentChange"
                        :total="myTotal">
                    </el-pagination>
                </div>
            </div>
            <div v-if="activeIndex == '2'">
                <div class="title-box">
                    <span class="title">题库列表</span>
                    <span class="num">共 {{collTotal}} 条记录</span>
                    <span title="刷新" @click="collRefresh" class="el-icon-refresh-right"></span>
                </div>
                <div class="operation">
                    <el-form :inline="true" :model="collFormItem" class="demo-form-inline">
                        <el-form-item>
                            <el-input size="small" v-model="collFormItem.name" placeholder="请输入要搜索的题库名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input size="small" v-model="collFormItem.type" placeholder="请输入要搜索的题库类别"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onCollSerach">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-popconfirm
                                class="popconfirm"
                                title="确定取消已选中的题库吗？"
                                @confirm="batchCancelCollection"
                            >
                            <el-button slot="reference" size="small" type="danger">取消收藏</el-button>
                        </el-popconfirm>
                        
                    </div>
                </div>
                <el-table
                    v-loading="collTableLoading"
                    ref="multipleTable"
                    :data="collTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="collHandleSelectionChange"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="题库编号"
                        width="120"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.quesNo ? scope.row.quesNo : '暂无'}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        prop="name"
                        label="题库名称"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="type"
                        label="题库类别"
                    ></el-table-column>
                    
                    <el-table-column
                        align="center"
                        prop="createName"
                        label="创建人"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="num"
                        label="试题数"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="备注信息"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.remark ? scope.row.remark : '暂无'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="address"
                        width="300"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-link  type="primary" :underline="false" @click="toPreview(scope.row)" >预览</el-link>
                            <el-popconfirm
                                class="popconfirm"
                                title="确定从收藏列表删除该题库吗？"
                                @confirm="collDelete(scope.row)"
                            >
                                <el-link slot="reference"  type="primary" :underline="false">取消收藏</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-box">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="collPageSize"
                        @current-change="collCurrentChange"
                        :total="collTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyQuestionBank',
    components: {
    },
    data() {
        return {
            activeIndex: '1',
            myFormItem: {
                name: '',
                type: ''
            },
            myTableData: [],
            myTotal: 0,
            myPageSize: 10,
            myPageIndex: 1,
            myMultipleSelection: [],
            myTableLoading: false,
            collFormItem: {
                name: '',
                type: ''
            },
            collTableData: [
                {
                    id: 1,
                    name: 1
                },
                {
                    id: 2,
                    name: 2
                },
                {
                    id: 3,
                    name: 4
                }
            ],
            collTotal: 0,
            collPageSize: 10,
            collPageIndex: 1,
            collMultipleSelection: [],
            collTableLoading: false,
        }
    },
    created() {
        if (this.activeIndex == '1') {
            this.getMyData()
        }else {
            this.getcollData()
        }
    },
    methods: {
        getMyData() {
            this.myTableLoading = true
            let that = this
            let data = this.$qs.stringify({
                'isSystem': 0, // 0自建题库 1系统题库
                'name': this.myFormItem.name,
                'pageIndex': this.myPageIndex,
                'pageSize': this.myPageSize,
                'bankType': 0,
                'type': this.myFormItem.type // 题库类别
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankList}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    that.myTableLoading = false
                    if (res.code == '0'){
                        that.myTableData = res.resultBody.datas
                        that.myTotal = res.resultBody.total
                    } else {
                        that.myTableData = []
                        that.myTotal = 0
                    }
                },
            };
            this.$util.request(params);
        },
        getcollData() {
            this.collTableLoading = true
            let that = this
            let data = this.$qs.stringify({
                'name': this.collFormItem.name,
                'pageIndex': this.collPageIndex,
                'pageSize': this.collPageSize,
                'type': this.collFormItem.type, // 题库类别
                'bankType': 0
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankCollectBank}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    that.collTableLoading = false
                    if (res.code == '0'){
                        that.collTableData = res.resultBody.datas
                        that.collTotal = res.resultBody.total
                    } else {
                        that.collTableData = []
                        that.collTotal = 0
                    }
                },
            };
            this.$util.request(params);
        },
        handleSelect(key) {
            this.activeIndex = key
            if (this.activeIndex == '1') {
                this.getMyData()
            }else {
                this.getcollData()
            }
        },
        onMySerach() {
            this.myPageIndex = 1
            this.getMyData()
        },
        onCollSerach() {
            this.collPageIndex = 1
            this.getcollData()
        },
        collHandleSelectionChange(val) {
            
            this.collMultipleSelection = val;
        },
        myCreated(item) {
            // 创建试题
            this.$router.push(
                {
                    path: '/addTestQuestions',
                    query: {
                        bankId: item.id,
                        title: item.name,
                        depict: item.remark,
                        questionBank: 1
                    }
                }
            )
        },
        myEditQues(item) {
            // 编辑试题
            this.$router.push(
                {
                    path: '/addTestQuestions',
                    query: {
                        bankId: item.id,
                        title: item.name,
                        depict: item.remark,
                        isEdit: true,
                        questionBank: 1
                    }
                }
            )
        },
        myEditBank(item) {
            // 编辑题库
            this.$router.push({
                path: '/addQuestionBank',
                query: {
                    bId: item.id,
                    isSystem: 0,
                    bankType: 0,
                    questionBank: 1
                }
            })
        },
        toPreview(item) {
            // 预览
            // 当前examId是题库id
            sessionStorage.setItem("examId", item.id);
            this.$router.push({
                path: '/examPreview',
                query: {
                    id: item.id,
                    isBank: true
                }
            })
        },
        myHandleSelectionChange(val) {
            console.log(val)
            this.myMultipleSelection = val;
        },
        onDelMyLists() {
            let arr = []
            if (this.myMultipleSelection.length == 0) {
                this.$message({
                    message: '请先选择要删除的题库',
                    type: 'warning'
                });
                return
            }
            this.myMultipleSelection.forEach(info => {
                arr.push(info.id)
            })
            this.saveMyDelApi(arr)
        },
        myDelete(item) {
            let arr = [item.id]
            this.saveMyDelApi(arr)
        },
        saveMyDelApi(ids) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankDel}?ids=${ids}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.getMyData()
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        collDelete(item) {
            let arr = [item.id]
            this.collDeleteApi(arr)
        },
        batchCancelCollection() {
            let arr = []
            if (this.collMultipleSelection.length == 0) {
                this.$message({
                    message: '请先选择要取消收藏的题库',
                    type: 'warning'
                });
                return
            }
            this.collMultipleSelection.forEach(info => {
                arr.push(info.id)
            })
            this.collDeleteApi(arr)
        },
        collDeleteApi(ids) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankCancelBank}?bankIds=${ids}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.getcollData()
                        that.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        myCurrentChange(e) {
            this.myPageIndex = e
            this.getMyData()
        },
        collCurrentChange(e) {
            this.collPageIndex = e
            this.getcollData()
        },
        setNewQuestionBank(){
            this.$router.push({
                path: '/addQuestionBank',
                query: {
                    isSystem: 0,
                    bankType: 0,
                    questionBank: 1
                }
            })
        },
        myRefresh() {
            this.myPageIndex = 1
            this.myFormItem = {
                name: '',
                type: ''
            }
            this.getMyData()
        },
        collRefresh() {
            this.collPageIndex = 1
            this.collFormItem = {
                name: '',
                type: ''
            }
            this.getcollData()
        }
    }
}
</script>

<style lang="scss" scoped>
.MyQuestionBank{
    /deep/.el-menu{
        position: static;
    }
    .el-menu-demo{
        padding-left: 20px;
        border-bottom: 1px solid #bbb;
    }
    /deep/.el-menu--horizontal>.el-menu-item.is-active,
    /deep/.el-menu--horizontal>.el-menu-item{
        border-bottom: none !important;
    }
    /deep/.el-menu-item{
        font-size: 16px;
    }
    .el-icon-refresh-right{
        cursor: pointer;
    }
    .body{
        padding: 0 40px 50px 40px;
        .title-box{
            line-height: 42px;
            span{
                font-size: 12px;
                color: #A7A6A6;
            }
            .title{
                font-size: 14px;
                color: #696868;
            }
            span+span{
                margin-left: 10px;
            }
        }
        .operation{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .page-box{
            margin-top: 20px;
            text-align: center;
        }
        .popconfirm{
            margin-left: 10px;
        }
    }
}
/deep/.el-table__body-wrapper,
/deep/.el-table{
    overflow: inherit;
}
</style>
